<template>
  <div style="margin: 10px" class="adverUpdate">
    <el-card class="box-card" style="position: relative">
      <el-row>
        <el-col :span="24">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            :rules="rules"
            width="50%"
            style="width: 50%"
          >
            <el-form-item label="广告标题" prop="title">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="广告类型:">
              <el-radio-group v-model="form.type">
                <el-radio
                  :label="item.type"
                  :value="item.type"
                  :key="index"
                  v-for="(item, index) in typeList"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="标识:">
              <el-input-number
                v-model="form.mark"
                :min="1"
                :max="9999"
                label="描述文字"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="跳转链接">
              <el-input v-model="form.path"></el-input>
            </el-form-item>
            <el-form-item label="广告内容">
              <el-input
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 6 }"
                placeholder="请输入内容"
                v-model="form.content"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="广告图片" prop="pic">
              <!-- <el-input v-model="form.pic" style="width:60%;float: left;" readonly></el-input> -->
              <el-upload
                drag
                list-type="picture-card"
                action=""
                :before-upload="beforePic"
                multiple
                :limit="1"
                :file-list="fileList"
                :on-remove="RemovePic"
                :on-exceed="handlePic"
                :on-success="getPic"
                style="width: auto; float: left"
              >
                <i class="el-icon-picture-outline"></i>
                <br />
                <span class="uploadTip">将图片拖到此处，或点击上传</span>
              </el-upload>
              <input
                type="button"
                size="mini"
                class="bullet"
                style="display: inline-block; margin-top: 5px"
                @click.stop="dialogVisible = true"
                value="素材库选择"
              />
            </el-form-item>
            <!-- <el-form-item label="是否置顶">
							<el-switch v-model="form.topping" active-color="#13ce66" inactive-color="#dcdfe6">
							</el-switch>
						</el-form-item> -->
          </el-form>
        </el-col>
      </el-row>
      <el-row style="margin-top: 100px">
        <el-col :span="24">
          <button type="primary" class="submit" @click="onSubmit('form')">
            立即提交
          </button>
        </el-col>
      </el-row>
    </el-card>
    <!-- 素材库选择 -->
    <el-dialog title="素材库选择" :visible.sync="dialogVisible" width="50%">
      <files @selectPic="selectPic"></files>
    </el-dialog>
  </div>
</template>

<script>
import files from '../../components/picFile.vue'
export default {
  components: {
    files
  },
  data () {
    return {
      form: {
        title: '',
        content: '',
        path: '',
        pic: '',
        topping: true,
        id: '',
        type: '',
        mark: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请输入广告标题',
          trigger: 'blur'
        }],

        pic: [{
          required: true,
          message: '请选择广告图片',
          trigger: 'blur'
        }]
      },
      iden: '',
      fileList: [],
      showPiC: '',
      dialogVisible: false,
      typeList: []
    }
  },
  created () {
    this.iden = this.$route.query.iden
    if (this.iden === 'add') {
      this.getType()
      return
    } else {
      this.getData()
    }
    this.getType()
  },
  methods: {
    getData () {
      var list = this.$route.query.rows
      console.log(list)
      this.form.title = list.title
      this.form.pic = list.img
      this.form.path = list.path
      this.form.number = list.id
      this.form.content = list.contents
      this.form.topping = list.status == 1
      this.showPiC = list.img
      this.form.id = list.id
      this.form.type = list.type
      this.form.mark = list.mark
      this.fileList.push({ url: this.settings.apiBaseImg + list.img })
    },
    beforePic (file, fileList) {
      let objUrl = file
      let formData = new FormData()
      formData.append('file', objUrl)
      formData.append('uid', localStorage.getItem('uid'))
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/adver/upload',
        data: formData
      }).then((res) => {
        if (res.status == 200) {
          this.form.pic = res.data.data.url
          this.showPiC = res.data.data.url
          this.fileList = []
          this.fileList.push({ url: this.settings.apiBaseImg + res.data.data.url })
          obj.$message.success(res.data.message)
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    // 素材库选择图片
    selectPic (index, rows) {
      this.form.pic = rows.path
      this.showPiC = rows.path
      this.fileList = []
      this.fileList.push({ url: this.settings.apiBaseImg + rows.path })
      this.dialogVisible = false
    },
    getPic (file, fileList) {
      this.fileList = []
      this.fileList.push({ url: this.settings.apiBaseImg + file.data.url })
      this.form.pic = file.data.url
      this.showPiC = file.data.url
    },
    RemovePic () {
      this.form.pic = ''
    },
    handlePic (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    getType () {
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/adver/type/list',
        data: {

        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.typeList = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 添加
    onSubmit (formName) {
      if (this.$route.query.iden == 'add') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var obj = this
            obj.$http({
              method: 'post',
              url: 'api/v1/adver/add',
              data: {

                title: this.form.title,
                contents: this.form.content,
                path: this.form.path,
                img: this.form.pic,
                status: this.form.topping == true ? 1 : 0,
                mark: this.form.mark,
                type: this.form.type
              }
            }).then((res) => {
              if (res.data.status == 200) {
                this.$message.success('添加成功')
                this.$router.push({
                  path: '/home/advertManage'
                })
                this.form.title = '',
                  this.form.content = '',
                  this.form.path = '',
                  this.form.pic = '',
                  this.form.topping == true
              } else {
                this.$message.error(res.data.message)
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      } else {
        this.onUpdate(formName)
      }
    },
    // 修改
    onUpdate (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = this
          obj.$http({
            method: 'post',
            url: 'api/v1/adver/update',
            data: {
              id: this.form.id,

              title: this.form.title,
              contents: this.form.content,
              path: this.form.path,
              img: this.form.pic,
              status: this.form.topping == true ? 1 : 0,
              mark: this.form.mark,
              type: this.form.type
            }
          }).then((res) => {
            if (res.data.status == 200) {
              this.$message.success('修改成功！')
              this.$router.push({
                path: '/home/advertManage'
              })
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
.submit {
  width: 120px;
  height: 48px;
  background: #8896f6;
  box-shadow: 3px 2px 7px 1px rgba(0, 0, 0, 0.34);
  border-radius: 5px;
  border: 1px solid #8896f6;
  color: #ffffff;
  float: left;
  position: absolute;
  bottom: 0%;
  left: 8%;
}

.advanPic {
  width: 380px;
  vertical-align: middle;
  margin-left: 50px;
  margin-top: 50px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 205px;
}

.advanPic img {
  width: 100%;
  height: 100%;
}
.adverUpdate /deep/ .el-input__inner {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/content/update.vue